import {FC, ReactElement, useEffect, useRef, useState} from 'react'
import {InterestCategory} from 'shared/types'
import {Dots} from 'shared/ui/icons'
import {getInterestIcon} from './helper'
import styles from './styles.module.scss'

export const Interests: FC<{data: InterestCategory[]}> = ({data}) => {
  const [isDotsButton, setIsDotsButton] = useState(true)
  const [isShow, setIsShow] = useState(false)
  const interestsWrapperRef = useRef<HTMLDivElement | null>(null)
  const interestsRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const gap = Number(styles.gap)
    const widthDotsButton = Number(styles.widthDotsButton)

    const resizeHandler = () => {
      if (isShow) return

      if (!interestsRef.current || !interestsWrapperRef.current) return
      let width = interestsWrapperRef.current.offsetWidth - widthDotsButton - gap
      const chips = Array.from(interestsRef.current.children) as HTMLDivElement[]
      for (const chip of chips) {
        chip.style.display = ''
      }
      for (const chip of chips) {
        width -= chip.offsetWidth + gap
        if (width < 0) chip.style.display = 'none'
      }

      setIsDotsButton(width < 0)
    }

    resizeHandler()
    window.addEventListener('resize', resizeHandler)

    return () => window.removeEventListener('resize', resizeHandler)
  }, [interestsRef, isShow, data])

  const showHandler = () => {
    setIsShow(true)
    setIsDotsButton(false)

    if (!interestsRef.current) return
    const chips = Array.from(interestsRef.current.children) as HTMLDivElement[]
    chips.forEach((chip) => chip.style.display = '')
  }

  return (
    <div className={styles.interestsWrapper} ref={interestsWrapperRef}>
      <div className={`${styles.interests} ${isDotsButton ? styles.hide : ''}`} ref={interestsRef}>
        {data?.map(({interests, name}) =>
          interests.map((interest) =>
            <Tag
              key={interest.name}
              icon={getInterestIcon(name)}
              text={interest.name || ''}
            />
          )
        )}
      </div>

      {
        isDotsButton && !isShow
          ? <div className={`${styles.tag} ${styles.dotsButton}`} onClick={showHandler}>
            <div className={styles.icon}><Dots /></div>
          </div>
          : null
      }
    </div>
  )
}

const Tag: FC<{icon: ReactElement, text: string}> = ({icon, text}) => {
  return <div className={styles.tag}>
    <div className={styles.icon}>{icon}</div>
    {text}
  </div>
}